// @flow

import Game from '@/lib/game';
import Unit from '@/lib/unit';

export default class {
  game: Game;
  actions: { [key: string]: (() => void) | null };

  constructor(game: Game) {
    this.game = game;
  }

  setActions(actions: { [key: string]: () => void }) {
    this.actions = Object.assign(this.actions || {}, actions);
  }

  perform() {
    this.doIntroStep1();
    this.doIntroStep2();
    this.doIntroStep3();
  }

  // 苗木以上の樹木が増えたらチュートリアル表示
  doIntroStep1() {
    const action = this.actions['introStep1'];
    if (!action) return;

    const count = Object.entries(this.game.unitManager.units).reduce(
      (prev, [unitId, unit]: [string, *]) => {
        if (!!unit.template.type.match(/(_child|_young|_adult)$/)) {
          return prev + 1;
        }

        return prev;
      },
      0
    );

    if (count < 3) return;

    action();
    this.actions['introStep1'] = null;
  }

  // ゴールドが増えたらチュートリアル表示
  doIntroStep2() {
    const action = this.actions['introStep2'];
    if (!action) return;

    if (this.game.assetManager.gold < 100) return;

    action();
    this.actions['introStep2'] = null;
  }

  // 初めて種を買ったらチュートリアル表示
  doIntroStep3() {
    const action = this.actions['introStep3'];
    if (!action) return;

    if (this.game.assetManager.units.length === 0) return;

    action();
    this.actions['introStep3'] = null;
  }
}



// WEBPACK FOOTER //
// ./src/lib/wave_observer/wave_observer.js